var AcHtmlElement = /** @class */ (function () {
    function AcHtmlElement(element) {
        this.element = element;
    }
    AcHtmlElement.find = function (selector) {
        var element = document.querySelector(selector);
        return element === null ? null : new AcHtmlElement(element);
    };
    AcHtmlElement.create = function (el) {
        return new AcHtmlElement(document.createElement(el));
    };
    AcHtmlElement.prototype.getElement = function () {
        return this.element;
    };
    AcHtmlElement.prototype.addId = function (id) {
        this.element.id = id;
        return this;
    };
    AcHtmlElement.prototype.toggleClass = function (className, add) {
        if (add === void 0) { add = null; }
        if (add === null) {
            return this.element.classList.contains(className)
                ? this.removeClass(className)
                : this.addClass(className);
        }
        return add
            ? this.addClass(className)
            : this.removeClasses(className);
    };
    AcHtmlElement.prototype.addClass = function (className) {
        this.element.classList.add(className);
        return this;
    };
    AcHtmlElement.prototype.addClasses = function () {
        var _this = this;
        var classNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classNames[_i] = arguments[_i];
        }
        classNames.forEach(function (className) { return _this.addClass(className); });
        return this;
    };
    AcHtmlElement.prototype.removeClasses = function () {
        var _this = this;
        var classNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classNames[_i] = arguments[_i];
        }
        classNames.forEach(function (className) { return _this.removeClass(className); });
        return this;
    };
    AcHtmlElement.prototype.removeClass = function (className) {
        this.element.classList.remove(className);
        return this;
    };
    AcHtmlElement.prototype.setAttribute = function (name, value) {
        this.element.setAttribute(name, value);
        return this;
    };
    AcHtmlElement.prototype.setAttributes = function (attributes) {
        var _this = this;
        Object.keys(attributes).forEach(function (k) { return _this.setAttribute(k, attributes[k]); });
        return this;
    };
    AcHtmlElement.prototype.addHtml = function (html) {
        this.element.innerHTML = html;
        return this;
    };
    AcHtmlElement.prototype.append = function (element) {
        this.element.appendChild(element);
        return this;
    };
    AcHtmlElement.prototype.appendFound = function (selector) {
        var _this = this;
        document.querySelectorAll(selector).forEach(function (el) { return _this.append(el); });
        return this;
    };
    AcHtmlElement.prototype.appendSelfTo = function (element) {
        element.append(this.element);
        return this;
    };
    AcHtmlElement.prototype.prepend = function (element) {
        this.element.prepend(element);
        return this;
    };
    AcHtmlElement.prototype.prependSelfTo = function (element) {
        element.prepend(this.element);
        return this;
    };
    AcHtmlElement.prototype.css = function (property, value) {
        this.element.style[property] = value;
        return this;
    };
    AcHtmlElement.prototype.insertAfter = function (insertedElement) {
        var _a;
        try {
            (_a = this.element.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(insertedElement, this.element.nextElementSibling);
        }
        catch (e) {
            console.error("Not able to insert element after current node", this.element);
        }
    };
    AcHtmlElement.prototype.insertSelfBefore = function (referenceNode) {
        var _a;
        try {
            (_a = referenceNode.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(this.element, referenceNode);
        }
        catch (e) {
            console.error("Not able to insert element before current node", this.element);
        }
        return this;
    };
    AcHtmlElement.prototype.insertBefore = function (insertedElement) {
        var _a;
        try {
            (_a = this.element.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(insertedElement, this.element);
        }
        catch (e) {
            console.error("Not able to insert element before current node", this.element);
        }
        return this;
    };
    AcHtmlElement.prototype.addEventListener = function (event, listener) {
        this.element.addEventListener(event, listener);
        return this;
    };
    AcHtmlElement.prototype.addEventListeners = function (events, listener) {
        var _this = this;
        events.forEach(function (e) { return _this.addEventListener(e, listener); });
        return this;
    };
    AcHtmlElement.prototype.$ = function () {
        return this.getElement();
    };
    return AcHtmlElement;
}());
export default AcHtmlElement;
